import AthleteDetailsForm from './AthleteDetailsForm';

export default AthleteDetailsForm;
